/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Driver Icon component.
 */
export const AssetDriverIcon = (props: IconProps) => {
  const {stroke = undefined} = props;
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d='M20 18.32c2.999 0 5.429-2.35 5.429-5.248s-2.43-5.247-5.428-5.247c-2.998 0-5.429 2.35-5.429 5.247 0 2.899 2.43 5.248 5.429 5.248zM8 27.588a6 6 0 016-6h11a6 6 0 016 6v4.088a.5.5 0 01-.5.5h-22a.5.5 0 01-.5-.5v-4.088z'
        fill={iconColor}
        stroke={stroke} />
    </svg>
  );
};
AssetDriverIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey4
};
